import { RSCH_HTML_RENDITIONTRACKING } from './piwikTracking';
import commonStore from '../store/commonStore.js';
import UserAgentUtils from '../utils/general/userAgentUtils';
import $ from 'jquery';
import { replaceAll } from '../utils/general/enterKey';
import { getCVFrameUrl } from '../utils/general/general';

interface ISessionContext {
    authenticationType: string | undefined;
    deviceId: string;
    platformId: string;
    sessionId: string;
    vendorUserId: string | null;
    vendorUserType: string | null;
    cvUserId: string;
    crmUserId: string;
  }
  
const visibleComponentIdList:any = [];
export const RSCH_HTML_TRACKING_CONFIG = {
    trackLoadTimings: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        _HTML_RENDITION.customFrontPageLoadTime = new Date().getTime() - _HTML_RENDITION.timestampAtIndexHead;
        const timingProfile: any = {
            "eventId": "503",
            "browserPageLoadTime": (_HTML_RENDITION.customFrontPageLoadTime + _HTML_RENDITION.SERVER_REQUEST_TIME).toString(),
            "serverRequestProcessTime": (_HTML_RENDITION.SERVER_REQUEST_TIME).toString(),
            "componentId": "UE5",
            "componentName": "Record Timing",
            "HLCN": "Timing Info",
            "HLCC": "timing_info"
        };
        try {
            if (window.performance && window.performance.timing) {
                const timingData: any = window.performance.timing;
                const eventNames = eventsOrder;
                const events: any = {};
                const startTime = timingData.navigationStart || 0;
                let eventTime = 0;
                let totalTime = 0;
                for (let i = 0, l = eventNames.length; i < l; i++) {
                    const evt = timingData[eventNames[i]];

                    if (evt && evt > 0) {
                        eventTime = evt - startTime;
                        events[eventNames[i]] = eventTime.toString();
                        if (eventTime > totalTime) {
                            totalTime = eventTime;
                        }
                    }
                }
                timingProfile['totalPageLoadTime'] = (_HTML_RENDITION.customFrontPageLoadTime + _HTML_RENDITION.timestampAtIndexHead - timingData.navigationStart).toString();
                $.extend(timingProfile, events);
                console.log('timing', 'timingType calculated: totalPageLoadTime:' + timingProfile['totalPageLoadTime']);
            } else {
                console.log('timing', 'timingType calculated: browserPageLoadTime:' + timingProfile['browserPageLoadTime']);
            }
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "trackLoadTimings",
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                eventAction: 'PAGE_LOAD',
                trackingData:
                    piwikCustomTrackingData( RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "trackLoadTimings", timingProfile )
                };

            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);

        } catch (exception) {
            console.log('timing', 'failed to get window.performance');
        }
    },
    trackerInit: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        console.log(`Before calling piwiktracker init : ${_HTML_RENDITION.environment}`);
        RSCH_HTML_RENDITIONTRACKING.trackerInit("70", _HTML_RENDITION.environment);
        console.log("After calling piwiktracker init");
    },
    docOpenTrack: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "defaultTrack",
            eventType: "ready",
            eventAction: 'PAGE_LOAD',
            actionComponent: "DOCUMENT_OPEN",
            piwikTrackingEventType:RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE,
            trackingContextInfo: piwikTrackingContextInfo(RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE, "ready", {
                "sourceId": _HTML_RENDITION.parent_doc_id || 'null',
            }),
            pageTrackingData: {
                "eventId": "200",
                "componentId": "OP1",
                "componentName": "Document Open"
            },
            visibleComponentIdList: visibleComponentIdList
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
},

    trackAuthorNameClick: (analystId: string, title: string) => {
        const piwikEvent =
        {
            trackingType: "customTrackingCall",
            eventAction: 'CLICK',
            eventType: "analystNameClick",
            actionComponent: "ANALYST_NAME_LNK",
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "analystNameClick",
                {
                    "eventId": "1",
                    "analystName": title,
                    "componentId": "CCC1",
                    "componentName": "Analyst Name",
                    "analystId": analystId,
                    "eventLabel": `analystName:${title} analystId:${analystId}`,
                    "HLCN": "Author Block",
                    "HLCC": "author_block"
                }
            )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackAuthorEmailClick(email: string, analystId: string) {
        // Do the piwik callback on a delay when in conjunction with a mailto: link.
        // For some reason, otherwise the piwik call tends to get cancelled.
        // Possibly because the mailto: is seen as a navigation
        // away from the page- similar to unload handler issue.
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "analystEmailClick",
                eventAction: 'CLICK',
                actionComponent: 'ANALYST_EMAIL_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "analystEmailClick",
                    {
                        "eventId": "2",
                        "analystEmail": email,
                        "componentId": "CCC2",
                        "componentName": "Analyst Email",
                        "analystId": analystId,
                        "eventLabel": `analystEmail:${email}analystId:${analystId}`,
                        "HLCN": "Author Block",
                        "HLCC": "author_block"
                    }
                )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },
    trackAuthorPhoneClick(analystId: string) {
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "analystPhoneClick",
                eventAction: 'CLICK',
                actionComponent: 'ANALYST_PHONE_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "analystPhoneClick",
                        {
                            "eventId": "3",
                            "componentId": "CCC3",
                            "componentName": "Analyst Phone",
                            "analystId": analystId,
                            "eventLabel": `analystId:${analystId}`,
                            "HLCN": "Author Block",
                            "HLCC": "author_block"
                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1000);
    },
    trackAuthorPhoneIconClick(analystId: string, title: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "callBackClick",
            actionComponent: 'CALL_BACK_REQUEST_LNK',
            eventAction: 'CLICK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "callBackClick",
                    {
                        "eventId": "4",
                        "analystName": title,
                        "componentId": "CCC4",
                        "componentName": "Request a Call Back",
                        "analystId": analystId,
                        "eventLabel": `analystName:${title}analystId:${analystId}`,
                        "HLCN": "Author Block",
                        "HLCC": "author_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestCompanyModelClick: (ticker: string) => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "reqCompanyModelClick",
            eventAction: 'CLICK',
            actionComponent: 'REQUEST_A_MODEL_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "reqCompanyModelClick",
                    {
                        "eventId": "5",
                        "componentId": "CCC5",
                        "componentName": "Request a Model",
                        "ticker": ticker,
                        "eventLabel": "ticker:" + ticker,
                        "HLCN": "Financial Block",
                        "HLCC": "financial_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackRequestCorporateAccessClick(companyName: string, ticker: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "reqCorpAccessClick",
            eventAction: 'CLICK',
            actionComponent: 'CORPORATE_ACCESS_INTEREST_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "reqCorpAccessClick",
                    {
                        "eventId": "6",
                        "companyName": companyName,
                        "componentId": "CCC6",
                        "componentName": "Corporate Access Interest",
                        "ticker":ticker,
                        "eventLabel": `ticker:${ticker}`,
                        "HLCN": "Financial Block",
                        "HLCC": "financial_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackFinancialsEconomicForecastClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "EconomicsForecastClick",
            eventAction: 'CLICK',
            actionComponent: 'ECONOMICS_FORECAST_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "EconomicsForecastClick",
                    {
                        "eventId": "12",
                        "componentId": "IC12",
                        "componentName": "Economics Forecast",
                        "HLCN": "Economics Forecast",
                        "HLCC": "Economics Forecast"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackFinancialsCommoditiesForecast: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "CommoditiesForecastClick",
            eventAction: 'CLICK',
            actionComponent: 'COMMODITIES_FORECAST_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "CommoditiesForecastClick",
                    {
                        "eventId": "13",
                        "componentId": "IC8",
                        "componentName": "Commodities Forecast",
                        "HLCN": "Commodities Forecast",
                        "HLCC": "Commodities Forecast"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackFinancialsFxForecast: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "FXForecastClick",
            eventAction: 'CLICK',
            actionComponent: 'FX_FORECAST_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "FXForecastClick",
                    {
                        "eventId": "14",
                        "componentId": "IC9",
                        "componentName": "FX Forecast",
                        "HLCN": "FX Forecast",
                        "HLCC": "FX Forecast"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackFinancialsHouseViews: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "house_views_click",
            eventAction: 'CLICK',
            actionComponent: 'HOUSE_VIEW_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "house_views_click",
                    {
                        "eventId": "194",
                        "componentId": "IC7.4",
                        "componentName": "House Views RHS",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackTeamDirClick: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "author_directory_click",
            eventAction: 'CLICK',
            actionComponent: 'AUTHOR_DIRECTORY_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "author_directory_click",
                    {
                        "eventId": "195",
                        "componentId": "CS23",
                        "componentName": "Author Directory",
                        "teamName": _HTML_RENDITION.team_name,
                        "eventLabel": "teamName:" + _HTML_RENDITION.team_name,
                        "HLCN": "Author Block",
                        "HLCC": "author_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackSeriesLogoClick: (title: string) => {
        let eventId = "23";
        let componentId = "CS5.3";
        const eventName = "iconClick";
        let componentName = "More from the " + title + " Series Icon";
        if (title.toUpperCase().indexOf('HEAD TO HEAD') != -1) {
            eventId = "27";
            componentId = "CS5.6";
        }
        if (title.toUpperCase().indexOf('IN A GLOBAL CONTEXT') != -1) {
            eventId = "164";
            componentId = "CS17";
            componentName = "In A Global Context Icon";
        }
        if (title.indexOf('Sustainable & Responsible Investing') != -1) {
            eventId = "172";
            componentId = "CS19";
        }
        if (title.indexOf('Flagship') != -1) {
            eventId = "174";
            componentId = "CS20";
        }
        if (title.toUpperCase().indexOf('DEEP DIVE') != -1) {
            eventId = "196";
            componentId = "CS14";
        }
        if (title.toUpperCase().indexOf('DEFI') != -1) {
            eventId = "197";
            componentId = "CS14.1";
        }
        if (title.toUpperCase().indexOf('INNOVATION LAB') != -1) {
            eventId = "168";
            componentId = "CS18";
        }
        if (title.toUpperCase().indexOf('MACRO-TO-MICRO') != -1) {
            eventId = "198";
            componentId = "CS14.2";
        }
        if (title.toUpperCase().indexOf('SUPER-SECTOR') != -1) {
            eventId = "199";
            componentId = "CS14.3";
        }
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: eventName,
            eventAction: 'CLICK',
            actionComponent: componentName.toUpperCase(),
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    eventName,
                    {
                        "eventId": eventId,
                        "componentId": componentId,
                        "componentName": componentName,
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackSeriesLinkClick: (title: string) => {
        let eventId = "21";
        let eventName = "click";
        let componentId = "CS5";
        let componentName = "More from the " + title + " Series Link";
        let actionComponent =  `MORE_FROM_THE_${title.toUpperCase()}_SERIES_LNK`;
        if (title.toUpperCase().indexOf('HEAD TO HEAD') != -1) {
            eventId = "25";
        }
        if (title.toUpperCase().indexOf('IN A GLOBAL CONTEXT') != -1) {
            eventId = "165";
            componentId = "CS17.1";
            eventName = "global_context_mobile";
            componentName = "In A Global Context Mobile";
            actionComponent = 'IN_A_GLOBAL_CONTEXT_MOBILE';
        }
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: eventName,
            eventAction: 'CLICK',
            actionComponent,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    eventName,
                    {
                        "eventId": eventId,
                        "componentId": componentId,
                        "componentName": componentName,
                        "Branding Name": title,
                        "eventLabel": "Branding Name:" + title,
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackMustCLinkClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "mustCClick",
            eventAction: 'CLICK',
            actionComponent: 'MUST_C_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "mustCClick",
                    {
                        "eventId": "29",
                        "componentId": "CS6",
                        "componentName": "MustC Link",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackUpcomingEventsClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "eventCarouselClick",
            eventAction: 'CLICK',
            actionComponent: 'EVENT_CAROUSEL',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "eventCarouselClick",
                    {
                        "eventId": "33",
                        "componentId": "CS7",
                        "componentName": "Event Carousel",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackUpcomingEventsMoreInfoClick: (eventId: string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "moreInfoClick",
            eventAction: 'CLICK',
            actionComponent: 'MORE_INFO_CAROUSEL',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "moreInfoClick",
                    {
                        "eventId": "34",
                        "componentId": "CS7M",
                        "componentName": "More Info (on Event Carousel)",
                        "Event Carousel ID": eventId,
                        "eventLabel": `Event Carousel ID:${eventId}`,
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        "eventCarouselId": eventId
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackCampaignClick(name: string, isCvCampaign: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "campaignClick",
            eventAction: 'CLICK',
            actionComponent: 'CAMPAIGN_CAROUSEL',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "campaignClick",
                    {
                        "eventId": "35",
                        "componentId": "CS8",
                        "componentName": "Campaign_Carousel",
                        "Campaign ID": name,
                        "eventLabel": `Campaign ID:${name}`,
                        "isCVCampaign": (isCvCampaign).toString(),
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        'campaignId': name
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackCitisBestPeriodicalBarClick() {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Periodicalbarclick",
            eventAction: 'CLICK',
            actionComponent: 'PERIODICAL_EDITION_BAR',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Periodicalbarclick",
                    {
                        "eventId": "184",
                        "componentId": "CS21",
                        "componentName": "Periodical Edition Bar",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackRequestFinancials: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "financialsRHSLinkClick",
            eventAction: 'CLICK',
            actionComponent: 'FINANCIAL_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "financialsRHSLinkClick",
                    {
                        "eventId": "36",
                        "componentId": "IC1",
                        "componentName": "Financials RHS Link",
                        "HLCN": "Financial Block",
                        "HLCC": "financial_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFocusList: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "focusListClick",
            eventAction: 'CLICK',
            actionComponent: 'FOCUS_LIST_RHS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "focusListClick",
                    {
                        "eventId": "39",
                        "componentId": "IC10",
                        "componentName": "Focus List RHS",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackKeyResearchChanges: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "keyResearchChangesClick",
            eventAction: 'CLICK',
            actionComponent: 'KEY_RESEARCH_CHANGES_RHS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "keyResearchChangesClick",
                    {
                        "eventId": "203",
                        "componentId": "CS6",
                        "componentName": "Key Research Changes",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackGlobalThememachine: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "globalThemeMachineClick",
            eventAction: 'CLICK',
            actionComponent: 'GLOBAL_THEME_MACHINE_RHS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "globalThemeMachineClick",
                    {
                        "eventId": "70",
                        "componentId": "GTM70",
                        "componentName": "Global Theme Machine RHS",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFocusListUnderHeadLine: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "focusListClick",
            eventAction: 'CLICK',
            actionComponent: 'FOCUS_LIST_UNDER_HEADLINE_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "focusListClick",
                    {
                        "eventId": "40",
                        "componentId": "IC10L",
                        "componentName": "Focus List Under Headline",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackIndustryComparablesClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "industryComparablesClick",
            eventAction: 'CLICK',
            actionComponent: 'INDUSTRY_COMPARABLES_RHS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "industryComparablesClick",
                    {
                        "eventId": "41",
                        "componentId": "IC1I",
                        "componentName": "Industry Comparables RHS",
                        "HLCN": "Financial Block",
                        "HLCC": "financial_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackOpenVideo(url: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        parseAndSendforTracking(url); // "https://citi.kulu.net/view/ZFKSGFIu4lw"
        _HTML_RENDITION.videoOpenTs = new Date().getTime();
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "videoClick",
            eventAction: 'CLICK',
            actionComponent: 'VIDEO',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "videoClick",
                    {
                        "eventId": "139",
                        "componentId": "UB14",
                        "componentName": "Stand alone video play",
                        "url": url,
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCloseVideo: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        _HTML_RENDITION.videoCloseTs = new Date().getTime();
        const timeSpent = _HTML_RENDITION.videoCloseTs - _HTML_RENDITION.videoOpenTs;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "videoClick",
            eventAction: 'CLICK',
            actionComponent: 'VIDEO_CLOSE_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "videoClick",
                    {
                        "eventId": "43",
                        "componentId": "IC2",
                        "componentName": "Video",
                        "timeSpent": timeSpent + " (ms)",
                        "eventLabel": `timeSpent:${timeSpent}`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackESGMateriality: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "ESGMaterialityRHSclick",
            eventAction: 'CLICK',
            actionComponent: 'ESG_MATRIX_RHS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "ESGMaterialityRHSclick",
                    {
                        "eventId": "187",
                        "componentId": "IC7.3",
                        "componentName": "ESG Matrix RHS",
                        "eventLabel": `tabName: ESGMaterialityRHSclick`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogExpandAll: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_expand_all",
            eventAction: 'CLICK',
            actionComponent: 'BLOG_EXPAND_ALL_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_expand_all",
                    {
                        "eventId": "186",
                        "componentId": "IC7.3",
                        "componentName": "Blog Expand All Btn",
                        "eventLabel": `tabName: blog_expand_all`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogCopyUrl: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_copy_url",
            eventAction: 'CLICK',
            subPageId: 'BLOG_COPY_URL_POP',
            actionComponent: 'BLOG_COPY_URL_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_copy_url",
                    {
                        "eventId": "200",
                        "componentId": "UE10",
                        "componentName": "Blog Copy URL",
                        "HLCN": "User Experience",
                        "HLCC": "user_experience"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogPrint: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_print",
            eventAction: 'CLICK',
            actionComponent: 'BLOG_PRINT_ICON',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_print",
                    {
                        "eventId": "188",
                        "componentId": "UE10.1",
                        "componentName": "Blog Print",
                        "HLCN": "User Experience",
                        "HLCC": "user_experience"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogOtherTopics: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_other_topics",
            eventAction: 'CLICK',
            actionComponent: 'BLOG_OTHER_TOPICS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_other_topics",
                    {
                        "eventId": "189",
                        "componentId": "CS22",
                        "componentName": "Blog Other Topics",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogOtherAuthors: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_other_authors",
            eventAction: 'CLICK',
            actionComponent: 'BLOG_OTHER_AUTHERS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_other_authors",
                    {
                        "eventId": "190",
                        "componentId": "CS22.1",
                        "componentName": "Blog Other Authors",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogAllTopics: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_all_topics",
            eventAction: "CLICK",
            actionComponent: 'BLOG_ALL_TOPICS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_all_topics",
                    {
                        "eventId": "191",
                        "componentId": "CS22.2",
                        "componentName": "Blog All Topics",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogValueAndRisk: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_vr",
            eventAction: "CLICK",
            actionComponent: 'BLOG_VALUATION_AND_RISK_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_vr",
                    {
                        "eventId": "192",
                        "componentId": "UE10.2",
                        "componentName": "Blog Valuation and Risk",
                        "HLCN": "User Experience",
                        "HLCC": "user_experience"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBlogDisclosures: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "blog_disclosures",
            eventAction: "CLICK",
            actionComponent: 'BLOG_DISCLOSURES_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "blog_disclosures",
                    {
                        "eventId": "193",
                        "componentId": "UE10.3",
                        "componentName": "Blog Disclosures",
                        "HLCN": "User Experience",
                        "HLCC": "user_experience"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackPriceChartFilter: ($this: any, ticker: string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "priceChartZoomClick",
            eventAction: "CLICK",
            subPageId: 'PRICE_CHART_POP',
            actionComponent:'INTERACTIVE_PRICE_CHART_ZOOM',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "priceChartZoomClick",
                    {
                        "eventId": "45",
                        "componentId": "IC4",
                        "componentName": "Interactive Price Chart Zoom",
                        "ticker": ticker,
                        "filter": $this.textContent,
                        "eventLabel": `ticker:"${ticker},filter:${$this.textContent}`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFinancialsPriceChart: (ticker: string) => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "requestPriceChartClick",
            eventAction: "CLICK",
            subPageId: 'FIN_POP',
            actionComponent: 'INTERACTIVE_PRICE_CHART_TAB',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "requestPriceChartClick",
                    {
                        "eventId": "46",
                        "componentId": "IC4",
                        "componentName": "Interactive Price Chart RHS",
                        "ticker":ticker,
                        "filter": "3m",
                        "eventLabel": `ticker:${ticker},filter: 3m`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackFigureGalleryInBodyClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "figureGalleryClick",
            eventAction: "CLICK",
            actionComponent: 'FIGURE_GALLARY_IN_BODY_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "figureGalleryClick",
                    {
                        "eventId": "47",
                        "componentId": "IC5",
                        "componentName": "Figure Gallery in Body Link",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackGalleryScrollTo: (location: any) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "figureGalleryLinkClick",
            eventAction: "CLICK",
            actionComponent: 'FIGURE_GALLERY_FIND_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "figureGalleryLinkClick",
                    {
                        "eventId": "50",
                        "componentId": "IC5F",
                        "componentName": "Figure Gallery Find Lnk",
                        "figureId": location,
                        "eventLabel": `figureId:${location}`,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFinancialTabClick: (tabName: string) => {
        let eventId = "51";
        let componentId = "IC7";
        let componentName = "Financial Tab";
        let actionComponent = 'FINANCIAL_TAB';
        const eventName = "TabClick";
        const HLCN = "Interactive Content";
        const HLCC = "interactive_content";
        if (tabName == "financial summary") {
            eventId = "53";
            componentId = "IC7";
            componentName = "Financials in Industry Comparables";
            actionComponent = "FINANCIALS_IN_INDUSTRY_COMPARABLES_TAB";
        } else if (tabName == "industry comparables") {
            eventId = "38";
            componentId = "IC1";
            componentName = "Industry Comparables in Financials";
            actionComponent = 'INDUSTRY_COMPARABLES_IN_FINANCIALS_TAB';
        }

        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventAction: "CLICK",
            eventType: eventName,
            subPageId: 'FIN_POP',
            actionComponent,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    eventName,
                    {
                        "eventId": eventId,
                        "componentId": componentId,
                        "componentName": componentName,
                        "tabName": tabName,
                        "eventLabel": `tabName:${tabName}`,
                        "HLCN": HLCN,
                        "HLCC": HLCC
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackMultimediaClicks: (sourceType: string, eventStatus: boolean) => {
        if (sourceType == "MULTIMEDIA") {
            if (eventStatus) {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "multimediaBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `VIDEO_COLLAPSE_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "multimediaBlockClick",
                            {
                                "eventId": "42",
                                "componentId": "IC2",
                                "componentName": "Video Collapse",
                                "Maximize ": "Y",
                                "eventLabel": "Maximize:Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            } else {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "multimediaBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `MULTIMEDIA_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "multimediaBlockClick",
                            {
                                "eventId": "42",
                                "componentId": "IC2",
                                "componentName": "Video",
                                "Minimize ": "Y",
                                "eventLabel": "Minimize:Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            }
        } else if (sourceType == "MULTIMEDIAAUDIO") {

        } else if (sourceType == "RATINGBLOCK") {
            if (eventStatus) {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "ratingBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `RATING_BLOCK_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "ratingBlockClick",
                            {
                                "eventId": "44",
                                "componentId": "IC3",
                                "componentName": "Rating Block",
                                "Maximize ": "Y",
                                "eventLabel": "Maximize: Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            } else {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "ratingBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `RATING_BLOCK_COLLAPSE_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "ratingBlockClick",
                            {
                                "eventId": "44",
                                "componentId": "IC3",
                                "componentName": "Rating Block Collapse",
                                "Minimize ": "Y",
                                "eventLabel": "Minimize:Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            }

        } else if (sourceType == "USERDEFINED") {
            if (eventStatus) {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "userdefinedBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `USER_DEFINED_BLOCK_COLLAPSE_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "userdefinedBlockClick",
                            {
                                "eventId": "57",
                                "componentId": "UB1",
                                "componentName": "User Defined Block Collapse",
                                "Maximize ": "Y",
                                "eventLabel": "Maximize:Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            } else {
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "userdefinedBlockClick",
                    eventAction: "CLICK",
                    actionComponent: `USER_DEFIND_BLOCK_BTN`,
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "userdefinedBlockClick",
                            {
                                "eventId": "180",
                                "componentId": "UB17",
                                "componentName": "User Defined Block",
                                "Minimize ": "Y",
                                "eventLabel": "Minimize:Y",
                                "HLCN": "Interactive Content",
                                "HLCC": "interactive_content"
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            }

        }

    },

    trackScrollPercent(scrollPercent: any, totalJSONFileCount: any, isUpdatedRequest?:string
        ) {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const pageNumber = Math.ceil((scrollPosition / windowHeight));
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Scroll",
            eventAction: "SCROLL",
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "Scroll",
                {
                    "eventId": "60",
                    "componentId": "UB2",
                    "componentName": `Scroll Percent${isUpdatedRequest ? '' : 'Old'}`,
                    "HLCN": "User Behavior",
                    "HLCC": "user_behavior",
                    "percentFromTop": scrollPercent,
                    "totalJsonFileCount": totalJSONFileCount,
                    "pageNumber": pageNumber
                }
            )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);

        if (scrollPercent == "100") {
            const _piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "scrollEnd",
                eventAction: "SCROLL",
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "scrollEnd",
                        {
                            "eventId": "58",
                            "componentId": "UB2",
                            "componentName": "Scroll",
                            "HLCN": "User Behavior",
                            "HLCC": "user_behavior",
                            "pageNumber": pageNumber
                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(_piwikEvent);
        }
    },    
    
    trackScroll() {
        const windowHeight = window.innerHeight;
        let lastTime = 0;

        window.onscroll = () => {
            const currentTime = Date.now();
            if (currentTime - lastTime >= 1000) {
                const scrollPosition = window.scrollY;
                const pageNumber = Math.ceil((scrollPosition / windowHeight));
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "scrollStart",
                    eventAction: "SCROLL",
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "scrollStart",
                        {
                            "eventId": "59",
                            "componentId": "UB2",
                            "componentName": "Scroll",
                            "HLCN": "User Behavior",
                            "HLCC": "user_behavior",
                            "pageNumber": pageNumber
                        }
                    )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
                lastTime = currentTime;
            }
        };
    },

    trackContactUsClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "contactUsClick",
            eventAction: "CLICK",
            actionComponent: `CONTACT_US_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "contactUsClick",
                    {
                        "eventId": "61",
                        "componentId": "UE1",
                        "componentName": "Contact Us",
                        "HLCN": "User Experience",
                        "HLCC": "user_experience"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFeedbackClick: () => {
        setTimeout(function () {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "feedBackClick",
                eventAction: "CLICK",
                actionComponent: `FEED_BACK_LNK`,
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "feedBackClick",
                        {
                            "eventId": "62",
                            "componentId": "UE1",
                            "componentName": "Feed Back Footer",
                            "HLCN": "User Experience",
                            "HLCC": "user_experience"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },
    trackLabelslinksleftmenuClick: (tagName: any) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "labelsrightmenuClick",
            eventAction: "CLICK",
            actionComponent: `LABELS_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "labelslinksrightmenuClick",
                    {
                        "eventId": UserAgentUtils.isMobile.any() ? "69"  : "71" ,
                        "componentId":"UI3.4",
                        "componentName":"Labels In Tab",
                        "tagName":tagName,
                        "HLCN":"UI Controls",
                        "HLCC":"ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackLeftMenuTagsClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "labelsrightmenuClick",
            eventAction: "MOUSE_HOVER",
            actionComponent: `RHS_LABELS_MENU_ITEM`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "labelsrightmenuClick",
                    {
                        "eventId": "72",
                        "componentId": "UI3.5",
                        "componentName": "Labels right menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackMenuCopyTab: (url:string) => {
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "copyURLClick",
                eventAction: 'CLICK',
                eventDataId: url,
                eventDataType:'Copied URL',
                actionComponent: `RHS_COPY_URL_MENU_ITEM`,
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "copyURLClick",
                    {
                        "eventId": "75",
                        "componentId": "UI5.1",
                        "componentName": "Copy URL right menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackMenuCopyTitleTab: (CopyTitle:any) => {
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "copyTitleHeadlineClick",
                eventAction: 'CLICK',
                actionComponent: `RHS_COPY_TITLE_HEADLINE_MENU_ITEM`,
                eventDataId: CopyTitle,
                eventDataType:'Copied Title',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "copyTitleHeadlineClick",
                    {
                        "eventId": "290",
                        "componentId": "UI5.5",
                        "componentName": "Copy Title right menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackLeftMenuPrintClick: (ticker: string) => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "printrightmenuClick",
            eventAction: 'MOUSE_HOVER',
            actionComponent: `RHS_PRINT_MENU_ITEM`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "printrightmenuClick",
                    {
                        "eventId": "80",
                        "componentId": "UI5.5",
                        "componentName": "print right menu",
                        "Ticker": ticker,
                        "eventLabel": `Ticker${ticker}`,
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackLeftmenuCVTab: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "cvTabClick",
            eventAction: "CLICK",
            actionComponent: `CV_TAB`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "cvTabClick",
                    {
                        "eventId": "81",
                        "componentId": "UI6",
                        "componentName": "CV Tab",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackLeftMenuBackButtonClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "BackButtonClick",
            eventAction: "CLICK",
            actionComponent: `LEFT_MENU_BACK_BTN`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "BackButtonClick",
                    {
                        "eventId": "83",
                        "componentId": "UI6.3",
                        "componentName": "back button left menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackLeftMenuMoreTabClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "moreTabRightMenuClick",
            eventAction: "MOUSE_HOVER",
            actionComponent: `RHS_MORE_MENU_ITEM`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "moreTabRightMenuClick",
                    {
                        "eventId": "92",
                        "componentId": "UI8",
                        "componentName": "More Tab right menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackSavePdfClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            subPageId: 'RHS_MORE_MENU_ITEM',
            actionComponent: `SAVE_PDF_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "94",
                        "componentId": "UI8.2",
                        "componentName": "Save",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackManageSubscriptionClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            subPageId: 'RHS_MORE_MENU_ITEM',
            actionComponent: `MANAGE_SUBSCRIPTION_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "96",
                        "componentId": "UI8.4",
                        "componentName": "Manage Subscriptions",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackShareTabFeedbackClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            subPageId: 'RHS_MORE_MENU_ITEM',
            eventAction: "CLICK",
            actionComponent: `FEEDBACK_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "97",
                        "componentId": "UI8.5",
                        "componentName": "Feedback",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackUpdateContactDetailsClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            actionComponent: `UPDATE_CONTACT_DETAILS_LNK`,
            subPageId: 'RHS_MORE_MENU_ITEM',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "98",
                        "componentId": "UI8.6",
                        "componentName": "Update Contact Details",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCompatibilityTestClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "compatibilitytestlink",
            eventAction: "CLICK",
            actionComponent: `COMPATIBILITY_TEST_LNK`,
            subPageId: 'RHS_MORE_MENU_ITEM',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "compatibilitytestlink",
                    {
                        "eventId": "367",
                        "componentId": "UI9.6",
                        "componentName": "Compatibility Test Link",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackHelpClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            actionComponent: `HELP_LNK`,
            subPageId: 'RHS_MORE_MENU_ITEM',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "99",
                        "componentId": "UI8.7",
                        "componentName": "Help",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackShareTabCookiePolicyClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            subPageId: 'RHS_MORE_MENU_ITEM',
            actionComponent: `COOKIE_POLICY_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "101",
                        "componentId": "UI8.8",
                        "componentName": "Cookie Policy",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackReportingCalendar: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "reportingCalendarClick",
            eventAction: "CLICK",
            subPageId: 'RHS_MORE_MENU_ITEM',
            actionComponent: `REPORTING_CALENDER_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "reportingCalendarClick",
                    {
                        "eventId" : "102",
                        "componentId":"IC16",
                        "componentName":"Reporting Calendar",
                        "HLCN":"Reporting Calendar",
                        "HLCC":"reporting_calendar"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCVSearch(userId: string, searchStr: string) {

        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "CVSearch",
            eventAction: "CLICK",
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "CVSearch",
                    {
                        "eventId": "103",
                        "componentId": "CVS1",
                        "componentName": "CV search",
                        "HLCN": "CV search",
                        "HLCC": "CV search",
                        "eventLabel": "userId:" + userId + ",searchStr:" + searchStr,
                        "userId": userId,
                        "searchStr": searchStr
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRegionClick: (eventClassValue: any, region: string, position: string, childDocId: string) => {
        if (eventClassValue.indexOf('region-container') > -1) {
            RSCH_HTML_TRACKING_CONFIG.regionBarClick(region, childDocId);
        } else {
            RSCH_HTML_TRACKING_CONFIG.timelineClick(position, childDocId);
        }
    },

    trackMustReadForecast: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "MustReadClick",
            eventAction: "CLICK",
            actionComponent: `THE_POINT_MUST_READ_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "MustReadClick",
                    {
                        "eventId" : "107",
                        "componentId":"IC17",
                        "componentName":"The Point_MustRead",
                        "HLCN":"interactive_content",
                        "HLCC":"Interactive Content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackKeydataChanges: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Keydatachangesclick",
            eventAction: "CLICK",
            actionComponent: `KEY_DATA_CHANGES_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Keydatachangesclick",
                    {
                        "eventId" : "108",
                        "componentId":"IC18",
                        "componentName":"KeydataChanges",
                        "HLCN":"interactive_content",
                        "HLCC":"Interactive Content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCorporateCalendar: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "corporatecalendarclick",
            eventAction: "CLICK",
            actionComponent: 'CORPORATE_CALENDER_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "corporatecalendarclick",
                    {
                        "eventId" : "109",
                        "componentId":"IC19",
                        "componentName":"Corporate Calendar",
                        "HLCN":"interactive_content",
                        "HLCC":"Interactive Content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackEconomicsdatacalendar: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "economicsdatacalendarclick",
            eventAction: "CLICK",
            actionComponent: 'ECONOMICS_DATA_CALENDER_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "economicsdatacalendarclick",
                    {
                        "eventId" : "110",
                        "componentId":"IC20",
                        "componentName":"Economicsdata Calendar",
                        "HLCN":"interactive_content",
                        "HLCC":"Interactive Content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackGlobalMarketData: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "globalmarketdataclick",
            eventAction: "CLICK",
            actionComponent: 'GLOBAL_MARKET_DATA_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "globalmarketdataclick",
                    {
                        "eventId" : "111",
                        "componentId":"IC21",
                        "componentName":"Global Market data",
                        "HLCN":"interactive_content",
                        "HLCC":"Interactive Content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackDocumentClick(section: string, headLine: string, count: string, position: number, docId: string, parentDocId: string, docUrl: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const date = new Date();
        const time = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        const eventInfo = getPointDocumentsInfo(section, "eventId");
        const sectionNameToPass = `=${section}`;
        const componentInfo = getPointDocumentsInfo(section, "componentId");
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "documentClick",
            eventAction: "CLICK",
            actionComponent: `${section}_DOCUMENT_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "documentClick",
                    {
                        "eventId": (eventInfo != undefined && eventInfo) ? eventInfo + sectionNameToPass : "105" + sectionNameToPass,
                        "componentId": (componentInfo != undefined && componentInfo) ? componentInfo : "CS9",
                        "componentName": 'Documents Link in crosssell Tab',
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        "eventLabel": `headline : encodeURI(headLine) count:${count}
                            position:${position} childDocumentId:${docId}
                            section:${section} date/time:${time}
                            sourceId: ${_HTML_RENDITION.parent_doc_id}`,
                        "headline ": encodeURI(headLine),
                        "count": count,
                        "position": position,
                        "parentDocumentId": _HTML_RENDITION.doc_id,
                        "childDocumentId": docId,
                        "section ": section,
                        "section": section,
                        "date/time": time,
                        "sourceId": _HTML_RENDITION.parent_doc_id || 'null'
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackWhatsTrendingDocumentClick(section: string, headLine: string, count: string, position: number, docId: string, parentDocId: string, docUrl: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const date = new Date();
        const time = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +
            date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
        const eventInfo = getPointDocumentsInfo(section, "eventId");
        const sectionNameToPass = `=${section}`;
        const componentInfo = getPointDocumentsInfo(section, "componentId");
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "whatsTrendingDocumentClick",
            eventAction: "CLICK",
            actionComponent: `${section}_DOCUMENT_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "whatsTrendingDocumentClick",
                    {
                        "eventId": (eventInfo != undefined && eventInfo) ? eventInfo + sectionNameToPass : "201" + sectionNameToPass,
                        "componentId": (componentInfo != undefined && componentInfo) ? componentInfo : "CS9",
                        "componentName": 'Documents Link in crosssell Tab',
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        "eventLabel": `headline : encodeURI(headLine) count:${count}
                            position:${position} childDocumentId:${docId}
                            section:${section} date/time:${time}
                            sourceId: ${_HTML_RENDITION.parent_doc_id}`,
                        "headline ": encodeURI(headLine),
                        "count": count,
                        "position": position,
                        "parentDocumentId": _HTML_RENDITION.doc_id,
                        "childDocumentId": docId,
                        "section ": section,
                        "section": section,
                        "date/time": time,
                        "sourceId": _HTML_RENDITION.parent_doc_id || 'null'
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    regionBarClick(region: string, childDocId: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Regionbarclick",
            eventAction: "CLICK",
            actionComponent: 'REGION_BAR',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Regionbarclick",
                    {
                        "eventId": "112",
                        "componentId": "CS10",
                        "componentName": "Region bar",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        "parentDocumentId": (_HTML_RENDITION.doc_id).toString(),
                        "region": region,
                        "childDocumentId": (childDocId).toString()

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    timelineClick(position: string, childDocId: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "timelineClick",
            eventAction: "CLICK",
            actionComponent: 'TIMELINE',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "timelineClick",
                    {
                        "eventId": "113",
                        "componentId": "CS11",
                        "componentName": "timeline",
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell",
                        "parentDocumentId": (_HTML_RENDITION.doc_id).toString(),
                        "position": (position).toString(),
                        "childDocumentId": (childDocId).toString()

                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackSectionClick(tabCode: string, documentsDetail: any) {
        let eventId = "";
        let componentId = "";
        let componentName = "";
        const eventName = "sectionClick";

        if (tabCode == "FEATURED") {
            eventId = "114";
            componentId = "CS12";
            componentName = "Featured tab";
        } else if (tabCode == "POINT") {
            eventId = "116";
            componentId = "CS13";
            componentName = "The Point tab";
        } else {
            console.log("unknown event recorded:tabCode=" + tabCode.toUpperCase + ";documentsDetail=" + documentsDetail);
            return;
        }
        trackSectionClickContext(eventId, componentId, componentName, documentsDetail, eventName);
    },

    trackTOCLinks(index: number, companyName: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const trackingDetailsObj: any = {
            "eventId": "118",
            "componentId": "UB5",
            "componentName": "Section in Body",
            "HLCN": "User Behaviour",
            "HLCC": "user_behaviour",
            "parentDocumentId": _HTML_RENDITION.doc_id,
            "sectionSequenceNumber": (index).toString()
        };
        if (companyName != undefined) {
            trackingDetailsObj["companyName"] = companyName;
        }
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "sectionClick",
            eventAction: "CLICK",
            actionComponent: 'SECTION_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "sectionClick", trackingDetailsObj
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackRHSTOCLinks(sourceText: string) {
        const trackingDetailsObj: any = {
            "eventId": "65",
            "componentId": "UI2",
            "componentName": `${sourceText}_TABLE_OF_CONTENT_SECTION_LNK`,
            "HLCN": "UI Controls",
            "HLCC": "ui_controls",
        };
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "tableOfContentsClick",
            eventAction: "CLICK",
            actionComponent: `${sourceText}_TABLE_OF_CONTENT_SECTION_LNK`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "tableOfContentsClick", trackingDetailsObj
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackStorySectionOpen: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "sectionClick",
            eventAction: "CLICK",
            actionComponent: 'SECTION_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "sectionClick",
                    {
                        "eventId": "120",
                        "componentId": "UB7.1",
                        "componentName": "Section click Open",
                        "HLCN": "user_behaviour",
                        "parentDocumentId": _HTML_RENDITION.doc_id,
                        "HLCC": "User Behaviour"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackStorySectionClose: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "sectionClick",
            eventAction: "CLICK",
            actionComponent: 'SECTION_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "sectionClick",
                    {
                        "eventId": "121",
                        "componentId": "UB7.2",
                        "componentName": "Section click",
                        "HLCN": "user_behaviour",
                        "parentDocumentId": _HTML_RENDITION.doc_id,
                        "HLCC": "User Behaviour"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackViewMoreCrossSell(component: string) {
        setTimeout(() => {
            const componentname = component;

            const eventId = "123=" + componentname;
            const componentId = "UB8.10";
            const viewMoreText = `${componentname} View More Cross Sell`;

            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "ViewMoreCrossSellClick",
                eventAction: "CLICK",
                actionComponent: `${componentname}_VIEW_MORE_LNK`,
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "ViewMoreCrossSellClick",
                        {
                            "eventId": eventId,
                            "componentId": componentId,
                            "componentName": viewMoreText,
                            "HLCN": "User Behavior",
                            "HLCC": "user_behavior",
                            "section": componentname
                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },
    trackWhatsTrendingSeeMore(component: string) {
        setTimeout(() => {
            const componentname = component;

            const eventId = "202";
            const componentId = "UB8.10";
            const seeMoreText = `${componentname}`;

            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "seeMore",
                eventAction: "CLICK",
                actionComponent: `${componentname}_SEE_MORE_LNK`,
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "seeMore",
                        {
                            "eventId": eventId,
                            "componentId": componentId,
                            "componentName": seeMoreText,
                            "HLCN": "User Behavior",
                            "HLCC": "user_behavior",
                            "section": componentname
                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },
    
    trackPPTLeftNavigationClick(newSlide: string, previousSlide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "LeftArrowClick",
            eventAction: "CLICK",
            actionComponent: 'CAROUSEL_LEFT_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "LeftArrowClick",
                    {
                        "eventId": "129",
                        "componentId": "UB9.1",
                        "componentName": "Carousel left",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": previousSlide,
                        "newSlide": newSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);

    },

    trackPPTRightNavigationClick(newSlide: string, previousSlide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "RightArrowClick",
            eventAction: "CLICK",
            actionComponent: 'CAROUSEL_RIGHT_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "RightArrowClick",
                    {
                        "eventId": "130",
                        "componentId": "UB9.2",
                        "componentName": "Carousel right",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": previousSlide,
                        "newSlide": newSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCarouselsliderScroll(previousSlide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "SliderscrollClick",
            eventAction: "SCROLL",
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "SliderscrollClick",
                    {
                        "eventId": "131",
                        "componentId": "UB9.3",
                        "componentName": "slider scroll",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": previousSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPPTArrowBackClick(newSlide: string, previousSlide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "LeftChevronClick",
            eventAction: "CLICK",
            actionComponent: 'CAROUSEL_JUMP_TO_BEGINNING_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "LeftChevronClick",
                    {
                        "eventId": "132",
                        "componentId": "UB9.4",
                        "componentName": "Jump to Beginning",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": previousSlide,
                        "newSlide": newSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPPTArrowForwardClick(newSlide: string, previousSlide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "RightChevronClick",
            eventAction: "CLICK",
            actionComponent: 'CAROUSEL_JUMP_TO_END_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "RightChevronClick",
                    {
                        "eventId": "133",
                        "componentId": "UB9.5",
                        "componentName": "Jump to End",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": previousSlide,
                        "newSlide": newSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPPTSlideInputChange(newSlide: string) {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "SlideNumberEnter",
            eventAction: "CLICK",
            actionComponent: 'CAROUSEL_JUP_TO_SLIDE_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "SlideNumberEnter",
                    {
                        "eventId": "134",
                        "componentId": "UB9.6",
                        "componentName": "Jump to Slide",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": _HTML_RENDITION.previousSlide_slideInputChanged,
                        "newSlide": newSlide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPPTFullScreenView(slide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "ClickOnFullScreenView",
            eventAction: "CLICK",
            actionComponent: 'FULL_SCREEN_VIEW_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "ClickOnFullScreenView",
                    {
                        "eventId": "135",
                        "componentId": "UB9.7",
                        "componentName": "full screen view btn",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": slide,
                        "newSlide": slide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPPTBackToStandardView(slide: string) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "ClickonStandardView",
            eventAction: "CLICK",
            actionComponent: 'STANDARD_VIEW_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "ClickonStandardView",
                    {
                        "eventId": "136",
                        "componentId": "UB9.8",
                        "componentName": "Back to Standard View",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior",
                        "previousSlide": slide,
                        "newSlide": slide
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPollSubmit: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Poll_submit_click",
            eventAction: "CLICK",
            actionComponent: 'POLL_SUBMIT_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Poll_submit_click",
                    {
                        "eventId": "137",
                        "componentId": "IC22",
                        "componentName": "Poll Submit",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCVMacroToolsEvent(name: string, position: number, url: string) {
        const publicationDisplayName = name;
        const publicationPosition = position;
        const cvMacroLinksTotalCount = $(".cvMacroTools .cvmacrotools-publications").length;
        const openUrl= url ;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "CitiToolClick",
            eventAction: "CLICK",
            actionComponent: 'CITI_TOOL_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "CitiToolClick",
                    {
                        "eventId":"138=" + publicationDisplayName,
                        "componentId": "IC23",
                        "componentName": "Citi Tool",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Position": publicationPosition,
                        "ToolCount": cvMacroLinksTotalCount,
                        "ToolCode": publicationDisplayName,
                        "openUrl":openUrl,
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        console.log("openUrl :: " + openUrl);
    },

    trackDataSummaryLink: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "sectionclick",
            eventAction: "CLICK",
            actionComponent: 'DATA_SUMMARY_SECTION_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "sectionclick",
                    {
                        "eventId": "140",
                        "componentId": "UB10",
                        "componentName": "Data Summary Section Link",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackSectionLinkExpand: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "expandsectionlink",
            eventAction: "CLICK",
            actionComponent: 'SECTION_EXPAND_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "expandsectionlink",
                    {
                        "eventId": "142",
                        "componentId": "UB10.2",
                        "componentName": "Section expand btn ",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackSectionLinkCollapse: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "collapsesectionlink",
            eventAction: "CLICK",
            actionComponent: 'SECTION_COLLAPSE_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "collapsesectionlink",
                    {
                        "eventId": "143",
                        "componentId": "UB10.3",
                        "componentName": "Section collapse btn",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackAudioPlayClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "audioClick",
            eventAction: "CLICK",
            actionComponent: 'AUDIO_PLAY_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "audioClick",
                    {
                        "eventId": "167",
                        "componentId": "UB16",
                        "componentName": "Standalone Audio Play",
                        "HLCN": "User Behavior",
                        "HLCC": "user_behavior"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackReportsToRevistClick: (analystName: string, authorWithAC: string) => {
        const piwikEvent =
        {
            trackingType: "customTrackingCall",
            eventType: "analystReportstoRevisit",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_REPORTS_TO_REVISIT_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "analystReportstoRevisit",
                {
                    "eventId": "145",
                    "analystName": analystName,
                    "componentId": "CCC8",
                    "componentName": "Reports to Revisit",
                    "analystId": analystName,
                    "eventLabel": `analystName:${authorWithAC}analystId:${analystName}`,
                    "HLCN": "Author Block",
                    "HLCC": "author_block"
                }
            )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestBullBearClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "bullbearclick",
            eventAction: "CLICK",
            subPageId:'BB_POP',
            actionComponent: 'BULL_BEAR_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "bullbearclick",
                    {
                        "eventId": "146",
                        "componentId": "IC22",
                        "componentName": "Bull/Bear",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open Bull/Bear picture from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestCatalystWatchClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'CATALYST_WATCH_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "147",
                        "componentId": "IC23",
                        "componentName": "Catalyst Watch",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open Catalyst Watch from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackPrivacyPolicyFooterClick: () => {
        setTimeout(function () {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "PrivacyPol_Footer",
                eventAction: "CLICK",
                actionComponent: 'PRIVACY_POLICY_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "PrivacyPol_Footer",
                        {
                            "eventId": "148",
                            "componentId": "UE6",
                            "componentName": "Privacy Policy Footer",
                            "HLCN": "User Experience",
                            "HLCC": "user_experience"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackShareTabPrivacyPolicyClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: 'CLICK',
            subPageId: 'RHS_MORE_MENU_ITEM',
            actionComponent: 'PRIVACY_POLICY_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "150",
                        "componentId": "UI8.9",
                        "componentName": "Privacy Policy Right Tab",
                        "HLCN": "Share Tab",
                        "HLCC": "share_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackShareTabCompatabilityTestClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "shareTabClick",
            eventAction: "CLICK",
            actionComponent: 'COMPATABILITY_TEST_LNK',
            subPageId: 'RHS_MORE_MENU_ITEM',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "shareTabClick",
                    {
                        "eventId": "150",
                        "componentId": "UI8.9",
                        "componentName": "Compatability Test",
                        "HLCN": "More Tab",
                        "HLCC": "more_tab"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFigureGalleryCollapse: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "figure_gallery_collapse",
            eventAction: "CLICK",
            actionComponent: 'FIGURE_GALLERY_COLLAPSE_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "figure_gallery_collapse",
                    {
                        "eventId": "155",
                        "componentId": "IC25",
                        "componentName": "Figure Gallery Collapse",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFigureGalleryExpand: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "figure_gallery_expand",
            eventAction: "CLICK",
            actionComponent: 'FIGURE_GALLERY_EXPAND_BTN',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "figure_gallery_expand",
                    {
                        "eventId": "156",
                        "componentId": "IC25.1",
                        "componentName": "Figure Gallery Expand",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRelatedReportDocumentClick(ele: any) {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "related_document_open",
            eventAction: "CLICK",
            actionComponent: 'RELATED_DOCUMENT_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "related_document_open",
                    {
                        "eventId": "161",
                        "componentId": "CS16",
                        "componentName": "Related Document Open",
                        "position": ele.attr("position"),
                        "totalCount": ele.attr("count"), // total number of publications present (for example, 2 of 3)
                        "HLCN": "Cross Sell",
                        "HLCC": "cross_sell"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackStylesAndFactorClick() {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "styles_factors",
            eventAction: "CLICK",
            actionComponent: 'STYLES_FACTORS_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "styles_factors",
                    {
                        "eventId": "162",
                        "componentId": "IC24",
                        "componentName": "Styles and Factors",
                        "HLCN": "Financial Block",
                        "HLCC": "financial_block"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackTermsAndConditionsFooterClick: () => {
        setTimeout(function () {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "terms_and_conditions",
                eventAction: "CLICK",
                actionComponent: 'TERMS_AND_CONDITIONS_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "terms_and_conditions",
                        {
                            "eventId": "163",
                            "componentId": "UE7",
                            "componentName": "Terms and Conditions",
                            "HLCN": "User Experience",
                            "HLCC": "user_experience"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackCookiePolicyFooterClick: () => {
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "cookie_policy_footer",
                 eventAction: "CLICK",
                 actionComponent: 'COOKIE_POLICY_FOOTER_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "cookie_policy_footer",
                        {
                            "eventId": "166",
                            "componentId": "UE8",
                            "componentName": "Cookie Policy Footer",
                            "HLCN": "User Experience",
                            "HLCC": "user_experience"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackOfflineReading: () => {
        setTimeout(() => {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "reading_list_mobile",
                eventAction: "CLICK",
                actionComponent: 'READING_LIST_MOBILE_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "reading_list_mobile",
                        {
                            "eventId": "171",
                            "componentId": "UI9.1",
                            "componentName": "Add to Reading List Mobile",
                            "HLCN": "Share tab",
                            "HLCC": "share_tab"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    trackBBInBody: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "bb_body",
            eventAction: "CLICK",
            actionComponent: 'BULL_BEAR_IN_BODY_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "bb_body",
                {
                    "eventId": "176",
                    "componentId": "IC26",
                    "componentName": "Bull/Bear in Body",
                    "HLCN": "Interactive Content",
                    "HLCC": "interactive_content"
                }
            )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackCWInBody: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "cw_body",
            eventAction: "CLICK",
            actionComponent: 'CATALYST_WATCH_IN_BODY_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "cw_body",
                    {
                        "eventId": "177",
                        "componentId": "IC27",
                        "componentName": "Catalyst Watch in Body",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFinancialsThemes: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "themesclick",
            eventAction: "CLICK",
            subPageId: 'FIN_POP',
            actionComponent: 'THEMES_TAB',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "themesclick",
                    {
                        "eventId": "178",
                        "componentId": "IC7.1",
                        "componentName": "Themes tab",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Event": "themes"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFinancialsESGMateriality: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "ESGMaterialityclick",
            eventAction: "CLICK",
            subPageId: 'FIN_POP',
            actionComponent: 'ESG_MATRIX_TAB',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "ESGMaterialityclick",
                    {
                        "eventId": "186",
                        "componentId": "IC7.2", // not sure
                        "componentName": "ESG Profile",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Event": "ESGMaterialityclick"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackFinancialsDefinitions: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Defintionsclick",
            eventAction: "CLICK",
            subPageId: 'FIN_POP',
            actionComponent: 'DEFINITIONS_TAB',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Defintionsclick",
                    {
                        "eventId": "54",
                        "componentId": "IC7.5", // not sure
                        "componentName": "Definitions Tab",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Event": "Defintionsclick"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackAuthorImageClick: (analystName: string, analystId: string, authorWithAC: string) => {
        const piwikEvent =
        {
            trackingType: "customTrackingCall",
            eventType: "analystImageClick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_IMG',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "analystImageClick",
                {
                    "eventId": "179",
                    "analystName": analystName,
                    "componentId": "CCC9",
                    "componentName": "Analyst Image",
                    "analystId": analystId,
                    "eventLabel": `analystName:${analystName}analystId:${authorWithAC}`,
                    "HLCN": "Author Block",
                    "HLCC": "author_block"
                }
            )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackBookMeetingClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "BookMeetingClick",
            eventAction: "CLICK",
            actionComponent: 'BOOK_MEETING_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "bookMeetingClick",
                    {
                        "eventId": "183",
                        "componentId": "CCC10",
                        "componentName": "Book a Meeting",
                        "HLCN": "Author Block",
                        "HLCC": "author_block",
                        "Event": "BookMeetingClick"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackReadMoreClick: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "ReadMoreCitiResearchClick",
            eventAction: "CLICK",
            actionComponent: 'READ_MORE_CITI_RESEARCH_LNK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "readMoreCitiResearchClick",
                    {
                        "eventId": "204",
                        "componentId": "CCC11",
                        "componentName": "Read more Citi Research",
                        "eventLabel": `docId:${_HTML_RENDITION.doc_id}`,
                        "HLCN": "Author Block",
                        "HLCC": "author_block",
                        "parentDocumentId": (_HTML_RENDITION.doc_id).toString(),
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
    trackMediaTermsOfUseClick: () => {
        setTimeout(function () {
            const piwikEvent = {
                trackingType: "customTrackingCall",
                eventType: "MediaTOUclick",
                eventAction: "CLICK",
                actionComponent: 'MEDIA_TERMS_OF_USE_LNK',
                piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                trackingData: piwikCustomTrackingData(
                        RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                        "mediaTOUclick",
                        {
                            "eventId": "185",
                            "componentId": "UE9",
                            "componentName": "Media Terms of Use",
                            "HLCN": "User Experience",
                            "HLCC": "user_experience"

                        }
                    )
            };
            RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
        }, 1500);
    },

    getClickThruJSON(jsonData: any, hideDefaultComponents?: boolean) {
        const addToolCode = function (componentSelector: string, eventId: string) {
            const toolCodeArr: any = [];
            $(componentSelector).each(function (index, element) {
                toolCodeArr.push(eventId + "=" + $(element).text().trim());
            });
            eventId = toolCodeArr.toString();
            return eventId;
        };

        const addCrossSellTabNames = function (componentSelector: string, eventId: string) {
            const tabNames: any = [];
            $(componentSelector).each(function (index, element) {
                tabNames.push(eventId + "=" + $(element).attr('componentname'));
            });
            eventId = tabNames.toString();
            return eventId;
        };

        try {
            const eventIdList: any = [];
            $.each(jsonData, function (index, value) {
                const componentSelector = jsonData[index].componentSelector;
                const componentName = jsonData[index].componentName;
                const defaultToSend = (jsonData[index].isVisible == "true" && !hideDefaultComponents) ? true : false; // lazy load components (link-feedback component, kaltura/off the cuff does not have it, so set the hideDefaultComponents to true)
                let eventId = jsonData[index].eventId;
                let componentVisible = $(componentSelector).is(':visible');

                const isDeaden = $(componentSelector).hasClass("deaden");

                if (componentVisible && componentSelector.indexOf("cvMacroTools") > -1) { // cv macro tools
                    eventId = addToolCode(componentSelector, eventId);
                }

                if (componentVisible && componentSelector.indexOf("recommended_stack") > -1 && eventId == "105") {
                    eventId = eventId + "=RECOMMENDED";
                }
                if (componentVisible && componentSelector.indexOf("popular_stack") > -1 && eventId == "105") {
                    eventId = eventId + "=POPULAR";
                }
                if (componentVisible && componentSelector.indexOf("related_stack") > -1 && eventId == "105") {
                    eventId = eventId + "=RELATED";
                }
                if (componentVisible && componentSelector.indexOf("featured_stack") > -1 && eventId == "115") {
                    eventId = eventId + "=FEATURED";
                }
                if (componentVisible && componentSelector.indexOf("recommended_view_more") > -1 && eventId == "123") {
                    eventId = eventId + "=RECOMMENDED";
                }
                if (componentVisible && componentSelector.indexOf("popular_view_more") > -1 && eventId == "123") {
                    eventId = eventId + "=POPULAR";
                }
                if (componentVisible && componentSelector.indexOf("what's_trending_see_more") > -1 && eventId == "202") {
                    eventId = eventId ;
                }
                if (componentVisible && componentSelector.indexOf("What's_Trending_Document_link") > -1 && eventId == "201") {
                    eventId = eventId ;
                }
                if (componentSelector.indexOf("leftMenuCitiBackTabLi") > -1 && eventId == "83") {
                    eventId = eventId;
                    componentVisible = true;
                }
                // check for point and globalizer
                const productLabel = $("#back_to_parent a span").text();
                if (eventId == '122' && (productLabel.indexOf('The Point') > -1)) {
                    eventId = eventId;
                    componentVisible = true;
                } else if (eventId == '127' && (productLabel.indexOf('Roundup') > -1)) {
                    eventId = eventId;
                    componentVisible = true;
                }

                if ((defaultToSend || componentVisible) &&
                    !isDeaden &&
                    ($.inArray(eventId, eventIdList) === -1)) {			// default condition , component visible and if not deaden
                    eventIdList.push(eventId);
                    const componentId:string  =replaceAll(componentName?.toUpperCase(), " ", '_')
                    visibleComponentIdList.push(componentId);
                }

            });
            // console.log(`clickthru getClickThruJSON got the eventID's ${eventIdList}`);
            const eventIDsToSend = eventIdList.join(",");
            if (eventIDsToSend) {
                const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
                const timingData: any = window.performance.timing;
                const piwikEvent = {
                    trackingType: "customTrackingCall",
                    eventType: "clickThruEvents",
                    eventAction: "PAGE_LOAD",
                    piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    trackingData:
                        piwikCustomTrackingData(
                            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                            "clickThruEvents",
                            {
                                "eventId": "504",
                                "componentId": "OP1",
                                "componentName": "Record Events",
                                "HLCN": "Record Events",
                                "HLCC": "record_events",
                                "clickThruJson": eventIDsToSend,
                                "totalPageLoadTime":(_HTML_RENDITION.customFrontPageLoadTime + _HTML_RENDITION.timestampAtIndexHead - timingData.navigationStart).toString()
                            }
                        )
                };
                RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
            }

            // Render heat map if url parameter is_heatmap_view is true.
            // Manually setting .enable(true) to render current page.
            // HEAT_MAP.enable(true);
            // HEAT_MAP.render();
        }
        catch (e) {
            console.log("clickthru", "catch-block");
            // HTML_RENDITION.docOpenPiwikAlert(e.stack);
        }
    },

    trackRequestAnalystModelClick: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_MODEL_LINK',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "506",
                        "componentId": "IC23",
                        "componentName": "Analyst_Model_Click_btn",
                        "AnalystModelId":  dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open Analyst Model from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestAnalystModelOpenFileUrl: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "DOWNLOAD",
            actionComponent: 'ANALYST_MODEL_FILE_URL_DOWNLOAD',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "507",
                        "componentId": "IC24",
                        "componentName": "Analyst_Model_Download_link",
                        "AnalystModelId":  dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Download File Url on Analyst Model"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
   
    trackRequestAnalystModelOkClick: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_MODEL_COMPANY_MODEL_EMAIL_REQUEST_COMPLETED',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "508",
                        "componentId": "IC25",
                        "componentName": "Analyst_Model_OK_btn",
                        "AnalystModelId": dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Email Request of Company Model completed on Analyst Model from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestAnalystModelSubmitClick: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_MODEL_SUBMIT_COMPANY_REQUEST_EMAIL',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "509",
                        "componentId": "IC26",
                        "componentName": "Analyst_Model_Submit_btn",
                        "AnalystModelId": dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Submit email request of Company Model on Analyst Model from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestAnalystModelClose: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_MODEL_CLOSE',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "510",
                        "componentId": "IC27",
                        "componentName": "Analyst_Model_Close_btn",
                        "AnalystModelId": dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Close Analyst Model from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestAnalystModelCancel: (dataSubmissionId:string) => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ANALYST_MODEL_CANCEL',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "511",
                        "componentId": "IC28",
                        "componentName": "Analyst_Model_Cancel_btn",
                        "AnalystModelId": dataSubmissionId,
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Cancel Email Request of Company Model for Analyst Model from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestCompanyDashboardClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'COMPANY_DASHBOARD',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "512",
                        "componentId": "IC23",
                        "componentName": "Company Dashboard",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open Company Dashboard from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    
    trackLeftMenuClick: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "RHSMenuListClick",
            eventAction: 'rightMenuClick',
            actionComponent: `RHS_MENU_LIST`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "RHSMenuListClick",
                    {
                        "eventId": "209",
                        "componentId": "UI5.5",
                        "componentName": "RHS_Hamburger_Menu",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackLeftMenuHover: () => {
        const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "RHSMenuListHover",
            eventAction: 'MOUSE_HOVER',
            actionComponent: `RHS_MENU_LIST`,
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "RHSMenuListClick",
                    {
                        "eventId": "256",
                        "componentId": "UI9.0",
                        "componentName": "RHS_Hamburger_Menu_Hover",
                        "HLCN": "UI Controls",
                        "HLCC": "ui_controls"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestStylesScorePeersClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'STYLES_SCORE_VS_PEERS',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "513",
                        "componentId": "IC23",
                        "componentName": "Styles Score vs Peers",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open Styles Score vs Peers from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },

    trackRequestEsgMatrixClick: () => {
        const piwikEvent = {
            trackingType: "customTrackingCall",
            eventType: "Stcallclick",
            eventAction: "CLICK",
            actionComponent: 'ESG_MATRIX',
            piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            trackingData: piwikCustomTrackingData(
                    RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                    "Stcallclick",
                    {
                        "eventId": "514",
                        "componentId": "IC23",
                        "componentName": "ESG Matrix",
                        "HLCN": "Interactive Content",
                        "HLCC": "interactive_content",
                        "Notes": "Click to open ESG Matrix from RHS"
                    }
                )
        };
        RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
    },
};

$('body').on('click', '#requestSupplyChain', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "supplychain_click",
        eventAction: "CLICK",
        actionComponent: 'SUPPLY_CHAIN_LNK',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "supplychain_click",
                {
                    "eventId": "181",
                    "componentId": "IC7.28",
                    "componentName": "Supply Chain lnk",
                    "HLCN": "Interactive Content",
                    "HLCC": "interactive_content"
                }
            )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '.supplyChainLinkInBody', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "supplychain_body_click",
        eventAction: "CLICK",
        actionComponent: 'SUPPLY_CHAIN_IN_BODY_LNK',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "supplychain_body_click",
                {
                    "eventId": "182",
                    "componentId": "IC7.29",
                    "componentName": "Supply Chain in Body",
                    "HLCN": "Interactive Content",
                    "HLCC": "interactive_content"
                }
            )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '#infoTabButton', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "InfoTabClick",
        eventAction: "CLICK",
        actionComponent: 'INFO_ICON',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            "InfoTabClick",
            {
                "eventId": "68",
                "componentId": "UI3",
                "componentName": "Info",
                "HLCN": "UI Controls",
                "HLCC": "ui_controls"
            }
        )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '#tocTabButton, #tocTabBtn', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "TOCTabClick",
        eventAction: 'CLICK',
        actionComponent: 'TABLE_OF_CONTENTS_BTN',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            "TOCTabClick",
            {
                "eventId": "64",
                "componentId": "UI2",
                "componentName": "Table of Contents Tab",
                "HLCN": "UI Controls",
                "HLCC": "ui_controls"
            }
        )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '#tagsTabButton, #tagsTabBtn', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "LabelsTabClick",
        eventAction: "CLICK",
        actionComponent: 'LABELS_BTN',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            "LabelsTabClick",
            {
                "eventId": "70",
                "componentId": "UI3",
                "componentName": "Labels Tab",
                "HLCN": "UI Controls",
                "HLCC": "ui_controls"
            }
        )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '#shareTabButton', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "ShareTabClick",
        eventAction: 'CLICK',
        actionComponent: 'SHARE_BTN',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            "ShareTabClick",
            {
                "eventId": "84",
                "componentId": "UI7",
                "componentName": "Share Tab",
                "HLCN": "UI Controls",
                "HLCC": "ui_controls"
            }
        )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', 'img[id="bot-image"]', function (e) {
    const piwikEvent= {
        trackingType:"customTrackingCall",
        eventAction: 'CLICK',
        actionComponent: 'BOT_DETECTION_IMG',
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
            "bot_click",
            {
                "eventId" : "505",
                "componentId":"UB18",
                "componentName":"Bot Detection",
                "HLCN":"User Behavior",
                "HLCC":"user_behavior",
                "Event":"bot_detection"
            }
        )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
});

$('body').on('click', '#viewFinancialsDefinitions', function (e) {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventType: "clickViewFinancialsDefinitions",
        eventAction: "CLICK",
        actionComponent: 'VIEW_FINANCIALS_DEFINITIONS_LINK',
        piwikTrackingEventType: RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE,
        trackingData: piwikCustomTrackingData(
            RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.PAGE,
            "InfoTabClick",
            {
                "eventId": "COMPANY_PAGE_VIEW_FINANCIAL_DEFINITIONS_BTN",
                "componentId": "VIEW_FINANCIAL_DEFINITIONS_BTN",
            }
        )
    };

    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);

    const isCvFrameMapping  = window.HTML_RENDITION.initialData.cvFrameWrapping === "true";
    const financialsUrl = window.location.origin + '/directory/eppublic/company23/glossary/financials';
    const menuCode = commonStore.getState().commonStateReducer.menuCode;
    const updatedFinancialUrl = getCVFrameUrl(menuCode, financialsUrl, 'company_dir');
    window.open(updatedFinancialUrl);
});

const parseAndSendforTracking = function (videoURL: string) {
    /* let kuluId = videoURL.split("view/")[1];
    let contentId = kuluId.indexOf('?')>-1 ? kuluId.split("?")[0]: kuluId;
    let toSend = "VID"+contentId;
    if(typeof PORTAL!='undefined'  && typeof  PORTAL.UI !='undefined'
        &&  typeof PORTAL.UI.CP !='undefined' && PORTAL.UI.CP.trackContent){
        PORTAL.UI.CP.trackContent("", toSend, "1", "", "5") ;
    } */
};
const getPointDocumentsInfo = function (section: string, param: string) {
    if (section == "POINT" && param == "eventId")
        return "117";
    else if (section == "FEATURED" && param == "eventId")
        return "115";
    else if (section == "POINT" && param == "componentId")
        return "CS13.1";
    else if (section == "FEATURED" && param == "componentId")
        return "CS12.1";
};

const getClassName = function (elememntClass: string, delimiter: string) {
    const eleClassArr = elememntClass.split(" ");
    for (let i = 0; eleClassArr.length; i++) {
        if (eleClassArr[i].indexOf(delimiter) != -1) {
            const headingClass = eleClassArr[i].split('-');
            return headingClass[headingClass.length - 1];
        }
    }
};

const trackSectionClickContext = function (eventId: string, componentId: string, componentName: string, documentsDetail: any, eventName: string) {
    const date = new Date();
    const time = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate() + " " +
        date.getHours() + ":" + date.getMinutes() + ":" + date.getSeconds();
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventAction: 'CLICK',
        actionComponent: `${componentName}_LNK`,
        trackingData:
            RSCH_HTML_RENDITIONTRACKING.piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                eventName,
                {
                    "eventId": eventId,
                    "componentId": componentId,
                    "componentName": componentName,
                    "HLCN": "Cross Sell",
                    "HLCC": "cross_sell",
                    "eventLabel": "date/time" + time + ",documentsCount:" + documentsDetail.count + ",documentsDetail:"
                        + ((documentsDetail.documentsDetail instanceof Object) ? JSON.stringify(documentsDetail.documentsDetail) : documentsDetail.documentsDetail),
                    "date/time": time,
                    "documentsCount": documentsDetail.count,
                    "parentDocumentId": _HTML_RENDITION.doc_id,
                    "documentsDetail": documentsDetail.documentsDetail
                }
            )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
};

const trackBacktoRoundUpLink = function () {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventAction: 'CLICK',
        actionComponent: 'BACK_TO_ROUNDUP_BTN',
        trackingData:
            RSCH_HTML_RENDITIONTRACKING.piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "ViewMoreFromRoundupClick",
                {
                    "eventId": "127",
                    "componentId": "UI8.13",
                    "componentName": "Back to Roundup",
                    "HLCN": "User Behavior",
                    "HLCC": "user_behavior"
                }
            )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
};

const trackBacktoPointLink = function () {
    const piwikEvent = {
        trackingType: "customTrackingCall",
        eventAction: 'CLICK',
        actionComponent: 'BACK_TO_POINT_BTN',
        trackingData:
            RSCH_HTML_RENDITIONTRACKING.piwikCustomTrackingData(
                RSCH_HTML_RENDITIONTRACKING.piwikTrackingEventTypeEnum.NON_PAGE,
                "BacktoPointClick",
                {
                    "eventId": "122",
                    "componentId": "UI8.9",
                    "componentName": "Back to Point",
                    "HLCN": "User Behavior",
                    "HLCC": "user_behavior"
                }
            )
    };
    RSCH_HTML_RENDITIONTRACKING.publishPiwikEvent(piwikEvent);
};

const eventsOrder = [
    'navigationStart', 'redirectStart',
    'redirectEnd', 'fetchStart', 'domainLookupStart',
    'domainLookupEnd', 'connectStart', 'secureConnectionStart',
    'connectEnd', 'requestStart', 'responseStart', 'responseEnd',
    'unloadEventStart', 'unloadEventEnd', 'domLoading',
    'domInteractive', 'msFirstPaint', 'domContentLoadedEventStart',
    'domContentLoadedEventEnd', 'domContentLoaded', 'domComplete',
    'loadEventStart', 'loadEventEnd'
];

const piwikTrackingContextInfo= function (piwikTrackingEventTypeData: any, eventTypeData: any, trackingContextData: any) {
    try {
        // validation
        if (!eventTypeData) {
            throw new Error(
                'eventType is not defined. Cannot instantiate PiwikTrackingContextInfo');
        }
        if (trackingContextData && !(typeof (trackingContextData) == "object"))
            throw new Error(
                'trackingContext should be an object. Cannot instantiate PiwikTrackingContextInfo');
        if (isNaN(piwikTrackingEventTypeData)) {
            throw new Error(
                'piwikTrackingEventType is not defined. Cannot instantiate PiwikTrackingContextInfo');
        }
        return $.extend(trackingContextData, extendTrackingContextObject());
    } catch (e: any) {
        console.log(`Error in instantiation of PiwikTrackingContextInfo: ${e}`);
        if (e.stack) console.log(e.stack);
    }
};

const piwikCustomTrackingData= function (piwikTrackingEventTypeData: any, eventTypeData: any, trackingContextData: any) {
    try {
        // validation
        if (!eventTypeData) {
            throw new Error(
                'eventType is not defined. Cannot instantiate PiwikTrackingContextInfo');
        }
        if (trackingContextData && !(typeof (trackingContextData) == "object"))
            throw new Error(
                'trackingContext should be an object. Cannot instantiate PiwikTrackingContextInfo');
        if (isNaN(piwikTrackingEventTypeData)) {
            throw new Error(
                'piwikTrackingEventType is not defined. Cannot instantiate PiwikTrackingContextInfo');
        }
        return $.extend(trackingContextData, extendTrackingContextObject());
    } catch (e: any) {
        console.log(`Error in instantiation of PiwikTrackingContextInfo: ${e}`);
        if (e.stack) console.log(e.stack);
    }
};

const extendTrackingContextObject = () => {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;    
    const sessionContext: ISessionContext = commonStore?.getState().asyncStateReducer?.sessionContext?.data?.sessionContext;
    if (_HTML_RENDITION.platform == '100'){
        return {
            "requestId": _HTML_RENDITION.requestid,
            "partner_id": updatePartnerId(),
            "email_send_id": _HTML_RENDITION.emailSendId || 'null',
            "authentication_id": _HTML_RENDITION.user_id,
            "mode": _HTML_RENDITION.mode || 'null',
            "deviceId": _HTML_RENDITION.device_id || _HTML_RENDITION.deviceId,
            "channel": _HTML_RENDITION.copyUrlChannel,
            "subChannel": _HTML_RENDITION.copyUrlSubChannel,
            "vendor": _HTML_RENDITION.copyUrlVendor,
            "portalEnvironment": _HTML_RENDITION.portalEnvHeader || _HTML_RENDITION['x-portal-env'],
            "userAgent": navigator.userAgent,
            'sessionId': sessionContext?.sessionId,
        };
	} else {
        return {
            "requestId": _HTML_RENDITION.requestid,
            "partner_id": updatePartnerId(),
            "email_send_id": _HTML_RENDITION.emailSendId || 'null',
            "authentication_id": _HTML_RENDITION.user_id,
            "mode": _HTML_RENDITION.mode || 'null',
            "deviceId": _HTML_RENDITION.device_id || _HTML_RENDITION.deviceId,
            "channel": _HTML_RENDITION.channel,
            "subChannel": _HTML_RENDITION.sub_channel,
            "portalEnvironment": _HTML_RENDITION.portalEnvHeader || _HTML_RENDITION['x-portal-env'],
            "userAgent": navigator.userAgent,
            'sessionId': sessionContext?.sessionId,
        };
    }
};

const updatePartnerId = function () {
    const _HTML_RENDITION: any = commonStore.getState().asyncStateReducer.initialData;
    const valid_platform_ids_str = _HTML_RENDITION.alt_userids_readership?.replace(/['"]+/g, '');
    const valid_platform_ids = valid_platform_ids_str?.split(",");
    for (let id = 0; id < valid_platform_ids?.length; id++) {
        if (_HTML_RENDITION.platform === valid_platform_ids[id]) {
            _HTML_RENDITION.partner_login = _HTML_RENDITION.user_id.toLowerCase();
            break;
        }
    }
};

export default RSCH_HTML_TRACKING_CONFIG;
